import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Modal, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Authorization } from "../../../Context/Authorization";
const AddRole = ({ onClose, onAddRole }) => {
  const [roleName, setRoleName] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const Confiq = Authorization();
        const response = await fetch(`${Api}/api/users/permissions`, Confiq);
        if (response.ok) {
          const data = await response.json();
          setPermissions(data);
        } else {
          console.error("Error fetching permissions:", response.statusText);
          toast.error("Error fetching permissions");
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
        toast.error("Error fetching permissions");
      }
    };

    fetchPermissions();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!roleName) {
      newErrors.roleName = "Role name is required";
    }
    if (selectedPermissions.length === 0) {
      newErrors.selectedPermissions = "At least one permission is required";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }
    setSubmitMessage("New Role Successfully!");

    const formData = {
      roleName,
      permissions: selectedPermissions,
    };

    try {
      const Confiq = Authorization();
      const response = await fetch(`${Api}/api/users/roles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...Confiq.headers,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Added Successfully");
        onAddRole(result);
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };

  const handlePermissionChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedPermissions([...selectedPermissions, value]);
    } else {
      setSelectedPermissions(selectedPermissions.filter((id) => id !== value));
    }
  };

  return (
    <div className="stateForm">
      <Modal show onHide={onClose}>
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}

        <Modal.Header>
          <Modal.Title>Add Role</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formRoleName">
              <Form.Label>Role Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter role name"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                isInvalid={!!errors.roleName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.roleName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPermissions">
              <Form.Label>Permissions</Form.Label>
              {permissions.map((permission) => (
                <Form.Check
                  key={permission._id}
                  type="checkbox"
                  label={permission.permissionName}
                  value={permission._id}
                  checked={selectedPermissions.includes(permission._id)}
                  onChange={handlePermissionChange}
                  isInvalid={!!errors.selectedPermissions}
                />
              ))}
              {errors.selectedPermissions && (
                <div className="invalid-feedback d-block">
                  {errors.selectedPermissions}
                </div>
              )}
            </Form.Group>

            <Button type="submit">Submit</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddRole;
